// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14XXD","name":"styles_name__b0489","phone":"styles_phone__3YRR5"};